import { Add } from "@mui/icons-material";
import { Chip, Grid, IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { useState } from "react";
import { Address4, Address6 } from "ip-address";

interface Props {
    cidrs: string[];
    onAdd: (cidr: string) => void;
    onDelete: (cidr: string) => void;
}

export default function CIDRManager({ onAdd, onDelete, cidrs }: Props): JSX.Element {
    const [value, setValue] = useState<string>("");

    function onAddCIDR(): void {
        if (isValidIP()) {
            onAdd(value);
            setValue("");
        }
    }

    function isValidIP(): boolean {
        const check = parseCIDR(value);
        return typeof check !== "undefined";
    }

    function parseCIDR(cidr: string): Address4 | Address6 | undefined {
        try {
            return new Address4(cidr);
        } catch (_e) {
            try {
                return new Address6(cidr);
            } catch (_e) {
                return undefined;
            }
        }
    }

    function onKeyPress(ev: any) {
        if (ev.key === "Enter") {
            ev.preventDefault();
            onAddCIDR();
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={7}>
                <OutlinedInput
                    fullWidth
                    id="add-cidr"
                    type="text"
                    placeholder="Add a CIDR"
                    value={value}
                    notched={false}
                    onKeyDown={onKeyPress}
                    onChange={(event) => setValue(event.target.value)}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton color="primary" onClick={() => onAddCIDR()} edge="end">
                                <Add />
                            </IconButton>
                        </InputAdornment>
                    }
                />
                {!isValidIP() && (
                    <div style={{ fontSize: "13px", color: "red" }}>Should be a valid IPv4 or IPv6 address</div>
                )}
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    {cidrs.map((cidr, idx) => (
                        <Grid item key={`${cidr}-${idx}`}>
                            <Chip label={cidr} onDelete={() => onDelete(cidr)} />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
}
